import { createColumnHelper } from '@tanstack/react-table'
import { NumberInput } from '../../../Components/Common/Inputs/NumberInput/NumberInput'

export const ReceptionTableColumnHeader = ({ onQuantityChange, t }) => {
    const columnHelper = createColumnHelper()

    return [
        columnHelper.accessor('barcode', {
            id: 'barcode',
            header: t('BARCODE'),
            cell: info => info.getValue(),
        }),
        columnHelper.accessor(row => `${row.productName}${row.productReferenceCode ? ` (${row.productReferenceCode})` : ''}`, {
            id: 'description',
            header: t('DESCRIPTION'),
            cell: info => info.getValue(),
        }),
        columnHelper.accessor('pendingQuantity', {
            id: 'pendingQuantity',
            header: t('PENDING_QUANTITY'),
            cell: info => info.getValue(),
        }),
        columnHelper.accessor('receivedQuantity', {
            id: 'receivedQuantity',
            header: t('RECEIVED_QUANTITY'),
            cell: ({ row, getValue }) => {
                const value = (getValue() ?? '')
                const isInvalid = !!row.original.__invalid
                return (
                    <NumberInput
                        name={`receivedQuantity-${row.index}`}
                        required
                        value={value}
                        onChange={(e) => onQuantityChange(row.index, e.target.value)}
                        className={`receivedQtyInput ${isInvalid ? 'invalid' : ''}`}
                        inputMode="decimal"
                    />
                )
            },
        }),
    ]
}
